import { QuestionCircleOutlined } from '@ant-design/icons';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import CSS from 'csstype';
import React from 'react';

import TooltipComponent from 'components/atoms/TooltipComponent';

interface IInfoTooltip extends TooltipPropsWithTitle {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    title: string | any;
    style?: CSS.Properties;
}

const InfoTooltip: React.FC<IInfoTooltip> = props => {
    const { title, style, ...rest } = props;
    if (title)
        return (
            <TooltipComponent {...rest} title={title}>
                <QuestionCircleOutlined
                    style={{
                        fontSize: 20,
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        color: '#006866',
                        marginLeft: 10,
                        marginRight: 10,
                        ...style
                    }}
                />
            </TooltipComponent>
        );
    return <></>;
};

export default InfoTooltip;
